export enum VueModeEnum {
  PAR_POSTE = 'par-poste',
  PAR_ENERGIE = 'par-energie'
}
